import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../directive.js';
import rdiff from 'recursive-diff';
import { readUpdateSalary, saveUpdateSalary as _saveUpdateSalary, saveUpdateLDateLog as _saveUpdateLDateLog, updateSalaryReasonTypeList, getLogDetail as _getLogDetail, getSalaryNotice } from '@/api/payroll';
import { baseHeaders } from 'util/axios-request';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  components: {},
  props: {
    staffId: String,
    subProjectId: String,
    type: String
  },
  data: function data() {
    var _this = this;
    var self = this;
    return {
      baseHeaders: baseHeaders(),
      row: {},
      uploadUrl: baseURL + '/web/tool/upload_file',
      visible: false,
      loading: true,
      cStaffDetail: {
        salary_update_start_date: '',
        update_reason_type: ''
      },
      staffDetail: {
        salary_update_start_date: '',
        update_reason_type: ''
      },
      initFiles: [],
      reasonTypeList: {},
      fileFormat: ['.pdf', '.jpg', '.png'],
      // 日期选择控制器
      pickerOptions: {
        /**
         *  日期选择器可选范围
         * 上一条有效调薪记录的生效日期-1天~下一条有效调薪记录+1天
         */
        disabledDate: function disabledDate(time) {
          var min_date = self.staffDetail.update_min_date;
          var max_date = self.staffDetail.update_max_date;
          var min = min_date ? new Date(min_date).getTime() - 86400000 : 0;
          var max = max_date ? new Date(max_date).getTime() : 0;
          if (min && max) return time.getTime() > max || time.getTime() < min;
          if (min) return time.getTime() < min - 86400000;
          if (max) return time.getTime() > max + 86400000;
        }
      },
      dateRule: [{
        required: true,
        validator: function validator(rule, value, callback) {
          var message = rule.message;
          if (!value) return callback(new Error(message));else if (_this.isEffectDate) {
            rule.message = _this.$t('i18n.a7edca1c71894b46a8db702b0a0304b9');
            return callback(new Error(message));
          }
          return callback();
        },
        message: this.$t('1256'),
        trigger: 'change'
      }]
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      var diff = [];
      var diff1 = [];
      var arr = this.staffDetail.arr || [];
      // 判断出薪资项的数据是否有修改，没有修改不能保存
      diff = rdiff.getDiff(this.cStaffDetail, this.staffDetail);
      if (arr.length) {
        // 判断调薪薪资项是否一致，一致不能点击保存
        var last = [];
        var later = [];
        arr.forEach(function (item) {
          item.list.forEach(function (list) {
            last.push(Number(list.last.val));
            later.push(Number(list.later.val));
          });
        });
        diff1 = rdiff.getDiff(last, later);
      }
      if (diff.length > 0 && diff1.length > 0) return false;
      return true;
    },
    isEdit: function isEdit() {
      return function (val) {
        if (this.row.statusEdit) {
          if (this.row.statusEdit === 'check') return true;else {
            var date = new Date().getTime();
            var time = new Date(this.staffDetail.salary_update_start_date).getTime();
            if (this.row.is_cancel && time > date) {
              return false;
            } else {
              var arr = ['salary_update_start_date', 'update_reason_file', 'update_reason_type', 'update_reason_remark'];
              if (arr.includes(val)) return false;
            }
            return true;
          }
        }
        return false;
      };
    },
    isEffectDate: function isEffectDate() {
      var data = this.staffDetail.salary_update_start_date || '';
      var cData = this.cStaffDetail.salary_update_start_date || '';
      var effect = this.staffDetail.effect_salary_update_start_date || [];
      return data !== cData && effect.includes(data);
    }
  },
  methods: {
    init: function init(row) {
      this.row = row;
      this.staffDetail = {};
      this.visible = true;
      this.loading = true;
      if (row.statusEdit) {
        this.getLogDetail(row);
      } else this.getReadUpdateSalary(row);
      this.getReasonTypeList();
    },
    // 调薪历史详情
    getLogDetail: function getLogDetail(row) {
      var _this2 = this;
      _getLogDetail({
        staff_info_id: this.$route.params.staff_id,
        id: row.id
      }).then(function (res) {
        _this2.handleDetail(res.data || {});
      });
    },
    getReadUpdateSalary: function getReadUpdateSalary(row) {
      var _this3 = this;
      readUpdateSalary({
        staff_id: row.staff_id
      }).then(function (res) {
        _this3.handleDetail(res.data || {});
      });
    },
    handleDetail: function handleDetail(data) {
      if (!data.salary && !data.salary.later) return;
      var arr = [];
      var last = data.salary.last || [];
      var later = data.salary.later || [];
      last.forEach(function (lastItem, lastIndex) {
        arr.push({
          list: [],
          id: lastItem.id,
          name: lastItem.name
        });
        lastItem.list.forEach(function (item, index) {
          var laterItem = later[lastIndex].list[index];
          // is_salary_update 为0 取last的值，为1取later 里的值
          // if (Number(data.is_salary_update) !== 1) laterItem.val = item.val
          arr[lastIndex].list.push({
            last: item,
            later: laterItem
          });
        });
      });
      data.arr = arr;
      this.staffDetail = data;
      this.cStaffDetail = JSON.parse(JSON.stringify(data));
      var update_reason_type = data.update_reason_type;
      this.staffDetail.update_reason_type = !update_reason_type || update_reason_type === '0' ? '' : update_reason_type;
      var update_reason_file = this.staffDetail.update_reason_file;
      this.initFiles = update_reason_file ? [{
        name: update_reason_file,
        url: update_reason_file
      }] : [];
      this.loading = false;
    },
    getReasonTypeList: function getReasonTypeList() {
      var _this4 = this;
      updateSalaryReasonTypeList().then(function (res) {
        if (res && res.code === 1) {
          _this4.reasonTypeList = res.data;
        }
      });
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      }
    },
    exceedHandle: function exceedHandle() {
      this.$message.error(this.$t('payroll_management_58', {
        fileLimit: 1
      }));
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err) {
      this.$message.error('upload error');
      throw err;
    },
    // 上传成功+
    successHandle: function successHandle(res, file) {
      var response = res;
      var data = response.data;
      this.staffDetail.update_reason_file = data.object_url;
    },
    handlerBack: function handlerBack() {
      this.visible = false;
    },
    handleSubmitData: function handleSubmitData() {
      var salary = this.staffDetail.salary;
      this.staffDetail.arr.forEach(function (arr, arrIndex) {
        var lastList = [];
        var laterList = [];
        arr.list.forEach(function (item) {
          lastList.push(item.last);
          laterList.push(item.later);
        });
        salary.last[arrIndex].list = lastList;
        salary.later[arrIndex].list = laterList;
      });
      var data = {
        update_reason_type: this.staffDetail.update_reason_type,
        update_reason_file: this.staffDetail.update_reason_file,
        update_reason_remark: this.staffDetail.update_reason_remark,
        department_name: this.staffDetail.department_name,
        hire_date: this.staffDetail.hire_date,
        is_salary_update: this.staffDetail.is_salary_update,
        salary_update_start_date: this.staffDetail.salary_update_start_date,
        settlement_type: this.staffDetail.settlement_type,
        staff_code: this.staffDetail.staff_code,
        staff_info_id: this.staffDetail.staff_info_id,
        staff_name: this.staffDetail.staff_name,
        salary: salary
      };
      return data;
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this5 = this;
      this.$refs.staffForm.validate(function (valid) {
        if (valid) {
          getSalaryNotice({
            salary_update_start_date: _this5.staffDetail.salary_update_start_date,
            staff_info_id: _this5.staffDetail.staff_info_id,
            id: _this5.staffDetail.id,
            type: '1'
          }).then(function (res) {
            if (res.data && res.data.is_show) {
              var str = _this5.cStaffDetail.salary_update_start_date ? _this5.$t('i18n.308988651cb34894b413f04bb5a3928a') : _this5.$t('i18n.871a4c4dc1fe4465a0e1e5a72250d87d');
              _this5.$confirm(str, _this5.$t('229'), {
                confirmButtonText: _this5.$t('131'),
                cancelButtonText: _this5.$t('66'),
                type: 'warning'
              }).then(function () {
                if (!_this5.row.statusEdit) _this5.saveUpdateSalary();else _this5.saveUpdateLDateLog();
              }).catch(function () {});
            } else {
              if (!_this5.row.statusEdit) _this5.saveUpdateSalary();else _this5.saveUpdateLDateLog();
            }
          });
        }
      });
    },
    saveUpdateLDateLog: function saveUpdateLDateLog() {
      var _this6 = this;
      var data = Object.assign({}, this.staffDetail, this.handleSubmitData());
      _saveUpdateLDateLog(data).then(function (res) {
        if (res && res.code === 1) {
          _this6.$message({
            message: _this6.$t('886'),
            type: 'success'
          });
          _this6.visible = false;
          _this6.$emit('save');
        }
      });
    },
    saveUpdateSalary: function saveUpdateSalary() {
      var _this7 = this;
      var data = this.handleSubmitData();
      _saveUpdateSalary(data).then(function (res) {
        if (res && res.code === 1) {
          _this7.$message({
            message: _this7.$t('886'),
            type: 'success'
          });
          _this7.visible = false;
          _this7.$emit('save');
        }
      });
    }
  }
};